import { motion } from "framer-motion";

const BRANDS = [
  "Audi", "BMW", "Volkswagen", "Ford", "Mercedes-Benz", "Vauxhall",
  "Skoda", "SEAT", "Nissan", "Honda", "Toyota", "Porsche",
  "Mini", "Peugeot", "Renault", "Citroën", "Kia", "Hyundai",
  "Volvo", "Land Rover", "Jaguar", "Fiat", "Mazda", "Subaru",
];

const AREAS = [
  "Nottingham", "Derby", "Long Eaton", "Beeston", "West Bridgford",
  "Arnold", "Carlton", "Ilkeston", "Ripley", "Belper",
  "Mansfield", "Sutton-in-Ashfield", "Loughborough", "Chesterfield",
];

const SERVICES = [
  "ECU remapping",
  "Stage 1 remap",
  "Stage 2 remap",
  "Stage 3 custom tune",
  "diesel remapping",
  "DPF removal",
  "EGR delete",
  "AdBlue delete",
  "gearbox tuning",
  "DSG tuning",
  "van remapping",
  "chip tuning",
  "performance tuning",
  "mobile ECU remap",
];

export default function SeoLinkTree() {
  return (
    <section
      className="relative bg-carbon border-t border-white/10 py-24 md:py-32 px-6 md:px-10"
      data-testid="seo-linktree"
      aria-labelledby="seo-heading"
    >
      <div className="max-w-[1600px] mx-auto">
        <div className="grid grid-cols-12 gap-6 mb-16">
          <div className="col-span-12 md:col-span-4">
            <p className="font-mono text-[11px] uppercase tracking-[0.4em] text-volt">
              ◉ Coverage & Capability
            </p>
          </div>
          <div className="col-span-12 md:col-span-8">
            <h2
              id="seo-heading"
              className="font-display uppercase text-3xl md:text-5xl lg:text-6xl leading-[0.9] tracking-tighter"
            >
              Mobile car remapping <br />
              <span className="text-white/40">near you.</span>{" "}
              <span className="text-volt">Every make. Every stage.</span>
            </h2>
            <p className="font-body text-white/60 text-base md:text-lg leading-relaxed max-w-2xl mt-6">
              Looking for a <strong className="text-white">car remap near you</strong>? Mids
              Tuning is the East Midlands&rsquo; fully-mobile ECU remapping
              specialist. We deliver{" "}
              <strong className="text-white">custom-mapped Stage 1, Stage 2 and Stage 3 remaps</strong>,
              diesel tuning, DPF removal and gearbox tuning at your driveway,
              unit or place of work — no workshop trip required.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-[1px] bg-white/10 mb-12">
          {/* Makes */}
          <div className="col-span-12 md:col-span-6 lg:col-span-4 bg-carbon p-8">
            <div className="font-mono text-[11px] uppercase tracking-widest text-white/40 mb-6">
              / 01 · Makes we tune
            </div>
            <h3 className="font-display uppercase text-xl mb-6 leading-tight">
              ECU remapping for every mainstream brand
            </h3>
            <ul className="flex flex-wrap gap-2 font-mono text-xs">
              {BRANDS.map((b) => (
                <li
                  key={b}
                  className="px-3 py-1.5 border border-white/15 text-white/70 hover:border-volt hover:text-volt transition-colors"
                >
                  {b} remap
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className="col-span-12 md:col-span-6 lg:col-span-4 bg-carbon p-8">
            <div className="font-mono text-[11px] uppercase tracking-widest text-white/40 mb-6">
              / 02 · What we do
            </div>
            <h3 className="font-display uppercase text-xl mb-6 leading-tight">
              Remapping, tuning & diagnostics services
            </h3>
            <ul className="flex flex-wrap gap-2 font-mono text-xs">
              {SERVICES.map((s) => (
                <li
                  key={s}
                  className="px-3 py-1.5 border border-white/15 text-white/70 hover:border-volt hover:text-volt transition-colors"
                >
                  {s}
                </li>
              ))}
            </ul>
          </div>

          {/* Areas */}
          <div className="col-span-12 md:col-span-12 lg:col-span-4 bg-carbon p-8">
            <div className="font-mono text-[11px] uppercase tracking-widest text-white/40 mb-6">
              / 03 · Where we cover
            </div>
            <h3 className="font-display uppercase text-xl mb-6 leading-tight">
              Car remapping in Nottingham, Derby & beyond
            </h3>
            <ul className="flex flex-wrap gap-2 font-mono text-xs">
              {AREAS.map((a) => (
                <li
                  key={a}
                  className="px-3 py-1.5 border border-white/15 text-white/70 hover:border-volt hover:text-volt transition-colors"
                >
                  Remapping {a}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <motion.p
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="font-body text-white/50 text-sm md:text-base leading-relaxed max-w-4xl border-t border-white/10 pt-8"
        >
          Whether you&rsquo;re searching for <em className="text-white/80">car remapping near me</em>,
          a <em className="text-white/80">Stage 1 remap cost in Nottingham</em>,{" "}
          <em className="text-white/80">DPF removal in Derby</em>, or a{" "}
          <em className="text-white/80">mobile diesel tuner in the East Midlands</em>, Mids
          Tuning delivers dealer-grade, VIN-specific calibrations backed by a
          30-day peace-of-mind warranty and an archived stock file — so a full
          return-to-factory is always one call away.
        </motion.p>
      </div>
    </section>
  );
}
